export default __webpack_public_path__ + "static/media/582.582edc9c.png";